import { DocumentConnection } from '../../common/model/document-connection-base';
import { CompanyDocumentType, CompanyDocumentTypeToString } from './const/documentEnums';

export class CompanyDocument extends DocumentConnection<CompanyDocumentType> {
  constructor() {
    super();
  }

  get connectionTypeText(): string {
    return CompanyDocumentTypeToString(this.connectionType);
  }

  companyId: string;

  toJSON() {
    const result = super.toJSON();
    result['companyId'] = this.companyId;
    return result;
  }
}
